<template>

<app-view-sheet-field align="center" :is-sticky="isSticky" :field="field" :filter="filter">

    <span>{{ item.play.length }}</span>

</app-view-sheet-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky']

}

</script>

<style scoped>

</style>